export interface MarketShareNumberType {
  name: string
  id: MarketShareNumberTypeId
}

export enum MarketShareNumberTypeId {
  Percentage = 'percentage',
  Value = 'value',
}
